import * as React from 'react';
import { MessageToUserProps } from './types';
import { messageStatusOptions } from 'app/shell/constants';
import { ButtonInline} from 'ui';
import { DisplayTextWithLinks } from 'ui/common/display-text-with-links';
import styles from './message-to-user.scss';

export class MessageToUserComponent extends React.Component<MessageToUserProps> {

  private updateMessageStatus = () => {
    this.props.updateMessageStatus && this.props.messageStatus === messageStatusOptions.unread ?
      this.props.updateMessageStatus(this.props.messageId, messageStatusOptions.read) :
      this.props.updateMessageStatus(this.props.messageId, messageStatusOptions.unread);
  }

  public render() {
    const {messageText, messageSubject, messageDate, messageStatus, textMarkAsRead, textMarkAsUnread, updating, dateLabel} = this.props;
    const textMessageStatus = messageStatus === messageStatusOptions.unread ? textMarkAsRead : textMarkAsUnread;

    const statusStyle = messageStatus === messageStatusOptions.unread ? 'alert-info' : '';
    const updatingStyle = updating ? styles.updating : '';

    return (
      <article
        className={`alert ${statusStyle} ${styles.message} ${updatingStyle}`}>
        <header className="flex">
          <h3 className="flex-grow">{messageSubject}</h3>
          <div className={styles.date} aria-label={dateLabel}>{messageDate}</div>
        </header>
        <DisplayTextWithLinks text={messageText} className={styles.messageText}/>
        <ButtonInline onClick={this.updateMessageStatus} disabled={updating}>
          {textMessageStatus}
        </ButtonInline>
      </article>
    );
  }
}

export { MessageToUserComponent as MessageToUser };
